import { Skeleton } from '@nexelem/components';
import { rootGridTemplateColumns } from '../../../../utils/gridTemplateColumns';

const SimulationLotMainSkeletonItem = () => (
  <div
    className="grid items-center gap-2 rounded-xs border border-border-container px-2 py-3"
    style={rootGridTemplateColumns}
  >
    {/* Grid Column 1 */}
    <div className="flex justify-center gap-3">
      <Skeleton className="size-7 rounded-full" />
      <Skeleton className="size-7 rounded-full" />
    </div>

    {/* Grid Column 2 */}
    <div className="flex flex-col gap-1">
      <Skeleton className="h-3 w-3/5" />
      <Skeleton className="h-4.5 w-9/10" />
      <Skeleton className="h-3 w-3/5" />
    </div>

    {/* Grid Column 3 */}
    <div className="flex flex-col gap-1">
      <Skeleton className="h-3" />
      <Skeleton className="h-3" />
    </div>

    <div></div>

    {/* Grid Column 4 */}
    <div>
      <Skeleton className="h-4.5 w-30" />
    </div>

    {/* Grid Column 5 */}
    <div>
      <Skeleton className="h-4.5 w-30" />
    </div>

    {/* Grid Column 6 */}
    <div></div>

    {/* Grid Column 7 */}
    <div>
      <Skeleton className="h-4.5 w-9/10" />
    </div>

    {/* Grid Column 8 */}
    <div className="inline-flex justify-center gap-5">
      <Skeleton className="size-7" />
      <Skeleton className="size-7" />
    </div>
  </div>
);

type SimulationLotMainSkeletonProps = {
  count?: number;
};

export const SimulationLotMainSkeleton = ({ count = 3 }: SimulationLotMainSkeletonProps) => (
  <div className="flex w-full min-w-405 flex-col gap-3">
    {Array.from({ length: count }).map((_, index) => (
      <SimulationLotMainSkeletonItem key={`skeleton-${index}`} />
    ))}
  </div>
);
